import type { BlockProps } from '../../lib/card';
import { CardLayout } from '../../lib/card';
import { MediaTypeIcon } from '../components';
import { usePost } from '../Post';

export function CardMediaTypeLayer(forwardingProps: BlockProps) {
  const { media } = usePost();

  return (
    <CardLayout.Layer _right _space={8} {...forwardingProps}>
      <MediaTypeIcon type={media?.type} />
    </CardLayout.Layer>
  );
}
